import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
export function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  const faqs = [{
    q: 'Is this suitable for online coaches or just face-to-face PTs?',
    a: 'Both. The principles of client acquisition, sales, and retention apply universally. Volume 6 specifically covers transitioning to hybrid and online models.'
  }, {
    q: 'Are the templates editable?',
    a: 'Yes, 100%. You get access to Word, Excel, and Canva formats so you can add your own logo, brand colors, and tweak the wording to suit your style.'
  }, {
    q: "I'm just starting out. Is this too advanced?",
    a: 'Not at all. Volume 1 is specifically designed for new trainers to set up their business structure correctly from day one, saving you months of mistakes.'
  }, {
    q: 'How do I access the materials?',
    a: "Instantly. As soon as you complete checkout, you'll receive an email with a secure link to download the entire MegaPack directly to your device."
  }, {
    q: 'Is this specific to NZ/AU?',
    a: 'The business principles are global, but the pricing examples, legal frameworks, and terminology are tailored for the Australian and New Zealand fitness markets.'
  }];
  return <section className="bg-nero-card py-16 md:py-24 border-t border-nero-border/20" data-id="element-18">
      <div className="max-w-3xl mx-auto px-4" data-id="element-19">
        <h2 className="text-white text-3xl font-bold text-center mb-10 font-playfair" data-id="element-20">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-21">
          {faqs.map((faq, idx) => <div key={idx} className="bg-nero-card border border-nero-border rounded-xl overflow-hidden transition-all duration-300" data-id="element-22">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full p-5 flex items-center justify-between text-left focus:outline-none" data-id="element-23">
                <span className="text-soft-gold font-bold text-base md:text-lg pr-4" data-id="element-24">
                  {faq.q}
                </span>
                {openIdx === idx ? <Minus className="w-5 h-5 text-soft-gold shrink-0" data-id="element-25" /> : <Plus className="w-5 h-5 text-soft-gold shrink-0" data-id="element-26" />}
              </button>

              <div className={`px-5 overflow-hidden transition-all duration-300 ease-in-out ${openIdx === idx ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-27">
                <p className="text-white/90 text-sm md:text-base leading-relaxed" data-id="element-28">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}